<script lang="ts" setup>
  import constants from "~~/constants";

  const { email } = defineProps<{ email: string }>();

  const errorMessage = ref("");

  const { mainBaseURL } = useRuntimeConfig().public;
  const { post } = apiRepository(mainBaseURL);
  const { t } = useI18n();
  async function onResend() {
    const { success, status, message } = await post(
      "/auth/forgot-password",
      { email },
    );

    if (success) {
      const toast = useToast();

      toast.add({
        title: t("toast.title.reset-link-sent"),
        duration: 1000,
      });
    }

    if (status <= constants.STATUS_INTERNAL_SERVER_ERROR) {
      errorMessage.value = message;
    } else {
      throw createError({
        statusCode: status,
        statusMessage: message,
      });
    }
  }
</script>

<template>
  <div class="space-y-6 text-center">
    <p class="text-lg font-semibold text-green-600">
      {{ $t("toast.title.reset-link-sent") }}
    </p>
    <p class="text-semibold text-gray-500">
      {{ $t("descriptions.reset-link-message") }}
    </p>
    <p>
      {{ $t("descriptions.did-not-receive-link") }}
      <UButton variant="ghost" @click="onResend">
        {{ $t("actions.resend-link") }}
      </UButton>
    </p>
  </div>
</template>

<style></style>
